import { APIClient, JavaAPIClient } from '../lib/apiHelper';


const {post, get, put, remove} = new APIClient()
const { get: _get, post: _post, put: _put, remove: _remove } = new JavaAPIClient();


export default {
	search: (search) => get('/user?' + (search ? new URLSearchParams(search).toString() : '')),
	modify: (user) => put('/user', user),
	remove: (user) => remove('/user'),
	listBy: (type, id, companyId) => _get('/user/list?type=' + type + '&id=' + id + '&companyId=' + companyId),

	list : (userCompany) => post('/user/list', userCompany),
	/**
	 * 개인 결재라인 가져오기
	 * @method GET
	 * @param
	 */
	getApproval: (companyId, search='') => _get(`/approval/${companyId}?${(search ? new URLSearchParams(search).toString() : 'type=tree')}`),
	getApprovalOrigin: (companyId) => get('/approval?companyId='+companyId),
	/**
	 * 결재라인 추가
	 * @method POST
	 * @param {OBJECT} approval
	 */
	addApproval: (approval) => _post('/approval', approval),
	/**
	 * 결재라인 수정
	 * @method PUT
	 * @param {OBJECT} approval
	 */
	putApproval: (approval) => _put('/approval', approval),
	/**
	 * 결재라인 삭제
	 * @method REMOVE
	 * @param {number} approvalId
	 */
	removeApproval: (approvalId) => _remove('/approval?approvalId=' + approvalId),
/**
	 * 휴가 유형 가져오기
	 * @method POST
	 * @param {OBJECT} restday
	 */ // typeArray, userId, companyId, (year)
	getUsersRestList: (restday) => _post('/user/restday', restday),
	/**
	 * 결재라인 엑셀 등록
	 * @method POST
	 * @param {OBJECT} approval
	 */
	addApprovalExcel: (approval) => _post('/approval-excel', approval),
	/**
	 * 인원정보 조회
	 * @method POST
	 * @param {OBJECT} user
	 */
	getUserInfoNew: (user) => _post('/user/getUserInfoNew', user),
	/**
	 * 인원정보 업데이트
	 * @method POST
	 * @param {OBJECT} user
	 */
	update: (user) => _post('/user/update', user)
};
